import { z } from 'zod';
import { eventSchema } from './envelope';

export const MESSAGING_MESSAGE_SENT_V1 = 'messaging.message.sent.v1' as const;

/**
 * Er is een persoonlijk bericht verstuurd.
 *
 * **Zonder de tekst**, en dat is geen oversight. Een event gaat door de outbox, komt in de logs van
 * de eventlus en blijft daar staan; een persoonlijk gesprek hoort niet in een eventspoor te belanden
 * dat voor heel andere doelen bewaard wordt. `notifications` heeft de tekst ook niet nodig: een
 * pushmelding bevat nooit inhoud (ADR-0038), alleen wie er iets stuurde.
 *
 * `recipientId` en niet `personIds`: een gesprek heeft precies twee deelnemers, en de afzender
 * hoort geen melding over zijn eigen bericht te krijgen.
 */
export const messageSentV1Schema = eventSchema({
  conversationId: z.guid(),
  senderId: z.guid(),
  recipientId: z.guid(),
  /** Alleen om de melding te kunnen maken: "Nieuw bericht van Ana". Nooit de inhoud. */
  senderDisplayName: z.string(),
  /**
   * Een gesprek over bedrijven heen (ACC-4): het id hoort dan bij `messaging_shared`, en de
   * melding opent dat gesprek en niet een gewoon.
   */
  crossTenant: z.boolean().optional(),
});

export type MessageSentV1 = z.infer<typeof messageSentV1Schema>;

export const messagingEventCatalog = {
  [MESSAGING_MESSAGE_SENT_V1]: messageSentV1Schema,
} as const;
